import {get} from "../utils";

export default host => () =>
  get(`${host}/users/exportAllLink`)
    .then(response => response.text())